import React, { useEffect, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBook, faImage, faAddressBook, faList, faClipboardList, faRectangleList, faTag, faBuilding } from '@fortawesome/free-solid-svg-icons'; // Importa los íconos necesarios
import { Link as Anchor } from "react-router-dom";
import { API_ENDPOINTS } from '../../../config/api';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
export default function CardsCantidad() {
    const [servicios, setServicios] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [banners, setBanners] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [turnos, setTurnos] = useState([]);


    useEffect(() => {
        cargarServicios();
        cargarUsuarios();
        cargarBanners();
        cargarCategoria();
        cargarTurnos();
    }, []);

    const cargarServicios = () => {
        fetch(API_ENDPOINTS.servicios, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || data || []);
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };


    const cargarUsuarios = () => {
        fetch(API_ENDPOINTS.usuarios, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                setUsuarios(data.usuarios || data || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarBanners = () => {
        fetch(API_ENDPOINTS.banners, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banners || data.banner || data || []);
            })
            .catch(error => console.error('Error al cargar banners:', error));
    };


    const cargarCategoria = () => {
        fetch(API_ENDPOINTS.categorias, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || data || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };


    const cargarTurnos = () => {
        fetch(API_ENDPOINTS.turnos, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                setTurnos(data.turnos || data || []);
            })
            .catch(error => console.error('Error al cargar turnos:', error));
    };

    return (
        <div className='CardsCantidad'>
            <Anchor to={`/dashboard/usuarios`} className='cardCantidad'>
                <FontAwesomeIcon icon={faUser} className='icons' />
                <div className='deColumn'>
                    <h3>Usuarios</h3>
                    <h2>{usuarios.length}</h2>
                </div>
            </Anchor>

            <Anchor to={`/dashboard/servicios`} className='cardCantidad'>
                <FontAwesomeIcon icon={faProductHunt} className='icons' />
                <div className='deColumn'>
                    <h3>Servicios</h3>
                    <h2>{servicios.length}</h2>
                </div>
            </Anchor>


            <Anchor to={`/dashboard/categorias`} className='cardCantidad'>
                <FontAwesomeIcon icon={faList} className='icons' />
                <div className='deColumn'>
                    <h3>Categorías</h3>
                    <h2>{categorias.length}</h2>
                </div>
            </Anchor>


            <Anchor to={`/dashboard/turnos`} className='cardCantidad'>
                <FontAwesomeIcon icon={faRectangleList} className='icons' />
                <div className='deColumn'>
                    <h3>Citas</h3>
                    <h2>{turnos.length}</h2>
                </div>
            </Anchor>

        </div>
    );
}
